// extracted by mini-css-extract-plugin
export var addButton = "_r-g";
export var cartCardSlider = "_r-c";
export var cartContainer = "_r-17";
export var cartPreview = "_r-16";
export var cartTotal = "_r-1c";
export var chartContainer = "_r-1u";
export var chartLoading = "_r-1v";
export var checkoutButton = "_r-1i";
export var checkoutButtonContainer = "_r-1b";
export var checkoutContainer = "_r-1k";
export var checkoutPreview = "_r-1j";
export var coveragePreview = "_r-z";
export var dark = "_r-15";
export var editorStyleIcon = "_r-w";
export var errorText = "_r-1s";
export var fakeCheckoutCheckbox = "_r-1q";
export var fakeCheckoutContainer = "_r-1m";
export var fakeCheckoutImage = "_r-1n";
export var fakeCheckoutTextContainer = "_r-1o";
export var fakeCheckoutTitle = "_r-1p";
export var fakeProduct = "_r-1d";
export var fakeProductImage = "_r-1f";
export var fakeProductInfo = "_r-1g";
export var fakeProductPrice = "_r-1h";
export var fakeRedoToggle = "_r-1e";
export var fullCartContainer = "_r-19";
export var fullCartHeader = "_r-18";
export var fullWidth = "_r-0";
export var generalSettingsToggle = "_r-f";
export var hoverable = "_r-x";
export var icon = "_r-1";
export var iconButtonContainer = "_r-1t";
export var light = "_r-13";
export var medium = "_r-14";
export var modalDescription = "_r-l";
export var modalLeftButton = "_r-k";
export var navigateIcon = "_r-y";
export var newSplitModal = "_r-j";
export var payNowButton = "_r-1l";
export var previewLink = "_r-2";
export var previewStyleSelector = "_r-10";
export var previewStyleSelectorSizer = "_r-11";
export var pricingSettingBlock = "_r-1r";
export var quarterCartContainer = "_r-1a";
export var richTextEditor = "_r-u";
export var richTextLabel = "_r-v";
export var selected = "_r-t";
export var selectedSplitType = "_r-p";
export var sidebarContent = "_r-9";
export var sidebarContentSection = "_r-a";
export var sidebarPaddedRow = "_r-d";
export var sidebarSectionHeader = "_r-7";
export var sidebarSectionTitle = "_r-8";
export var sidebarSettingRow = "_r-b";
export var sidebarStyleSelector = "_r-e";
export var skeletonBlock = "_r-12";
export var splitContent = "_r-q";
export var splitContentContainer = "_r-5";
export var splitFooterContainer = "_r-r";
export var splitFormActions = "_r-i";
export var splitHeaderContainer = "_r-h";
export var splitName = "_r-3";
export var splitPage = "_r-4";
export var splitSidebarContainer = "_r-6";
export var splitTypeContainer = "_r-m";
export var splitTypeDescription = "_r-o";
export var splitTypeSelection = "_r-n";
export var treatmentNameButton = "_r-s";